// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__MXr8G","modal":"Modal_modal__WdFzJ","slide-down":"Modal_slide-down__497Wc"};